// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__72Cpi","inputWrap":"Table_inputWrap__1R9dm","col":"Table_col__7CUVz","bmiTooltip":"Table_bmiTooltip__gvu9A"};